import { Link } from "react-router-dom";
import { useProducts } from "@/hooks/useProducts";
import { Skeleton } from "@/components/ui/skeleton";

const GiftSetSection = () => {
  const { data, isLoading } = useProducts(20);
  const sets = data?.filter((p) => /gift set/i.test(p.node.title)) ?? [];
  if (!isLoading && sets.length === 0) return null;
  return (
    <section id="gift-sets" className="py-16 lg:py-20 bg-background">
      <div className="container mx-auto px-6 lg:px-12 max-w-4xl">
        <div className="text-center mb-10">
          <p className="text-luxury text-muted-foreground mb-3">Gift Boxes</p>
          <h2 className="font-serif text-3xl md:text-4xl text-foreground mb-3">
            The Trio <span className="text-gold italic">Gift Sets</span>
          </h2>
          <p className="text-sm text-muted-foreground max-w-md mx-auto font-light">
            Three 10ml Premium Vegan Leather atomizers, presented in a signature gift box.
          </p>
        </div>
        <div className="grid grid-cols-3 gap-4 md:gap-8">
          {isLoading
            ? Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="aspect-[4/5] w-full" />)
            : sets.map(({ node }) => {
                const img = node.images.edges[0]?.node;
                const price = parseFloat(node.priceRange.minVariantPrice.amount).toFixed(2);
                return (
                  <Link key={node.id} to={`/product/${node.handle}`} className="group block text-center">
                    <div className="aspect-[4/5] overflow-hidden bg-secondary/40 mb-4">
                      {img && (
                        <img src={img.url} alt={img.altText || node.title} loading="lazy"
                          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                      )}
                    </div>
                    <h3 className="font-serif text-base md:text-lg text-foreground leading-tight mb-1">{node.title}</h3>
                    <p className="text-xs md:text-sm font-medium text-foreground mb-2">£{price}</p>
                    <span className="inline-block border-b border-foreground/20 pb-0.5 text-[9px] md:text-[10px] uppercase tracking-[0.2em] text-muted-foreground group-hover:border-foreground group-hover:text-foreground transition-colors">
                      Explore Set
                    </span>
                  </Link>
                );
              })}
        </div>
      </div>
    </section>
  );
};
export default GiftSetSection;
